import React from 'react';
import { Navigate } from 'react-router-dom';
import { useRedux } from '../../hooks';
import { changeSelectedChat } from '../../redux/actions';

const Index = (props: any) => {
    const { dispatch } = useRedux();
    dispatch(changeSelectedChat(null));
    return (
        <div>
            <Navigate to="/dashboard" />
        </div>
    );
};

export default Index;
